import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import settings from './settings'
import Axios from 'axios'
import Vue2TouchEvents from 'vue2-touch-events'
import vClickOutside from 'v-click-outside'
// import Eruda from 'eruda'

// проверяем наличие авторизации

const userID = JSON.parse(localStorage.getItem('userID'));
if (userID) {
  // добавляем во все запросы ID текущего пользователя
  Axios.defaults.headers.common['X-BitrixUserId'] = userID;
}
Axios.defaults.headers.common['X-APIKEY'] = settings.apiKey;
Axios.defaults.headers.common['Content-Type'] = 'application/json';
Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
Axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'false';
Axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PATCH, PUT, DELETE, OPTIONS';
Axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-APIKEY, X-BitrixUserId, Accept';

import store from './store'
import Vuelidate from 'vuelidate'
import Toasted from 'vue-toasted';
import BootstrapVue from 'bootstrap-vue'
var VueScrollTo = require('vue-scrollto');



// Eruda.init()

const VueInputMask = require('vue-inputmask').default

Vue.prototype.$axios = Axios;
Vue.prototype.$makeToast = function(title, variant, text, time,  append = false) {
  this.$bvToast.toast(text, {
      title: title,
      autoHideDelay: time,
      variant: variant,
      toaster: 'b-toaster-top-center',
      appendToast: append
  })
};

/**
 * name - string
 */
Vue.prototype.$localStorageSet = function(name, value){
  localStorage.setItem(name, JSON.stringify(value));
};

Vue.prototype.$localStorageGet = function(name){
  return JSON.parse(localStorage.getItem(name));
};

Vue.prototype.$localStorageDelete = function(name){
  localStorage.removeItem(name);
};

Vue.prototype.$goToCollection = function(){
  if(localStorage.getItem('currentCollectionInfo')){
    let collectionID = JSON.parse(localStorage.getItem('currentCollectionInfo')).collectionId;
    router.push('/catalog/' + collectionID)
  }
}


Vue.use(Vue2TouchEvents)
Vue.use(vClickOutside)
Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueInputMask)
Vue.use(BootstrapVue)
Vue.use(Toasted)
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -300,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
